import Register from '@/config/vuex/register'
/*
  업무용 로컬 상태 관리
*/

const init = () => {
  // Custom store 용 Map 정의

  var localMap = ''

  console.info('initUserStore()')

  if (window.vue.getStoreMap() === undefined) {
    localMap = new Map()
    window.vue.setStoreMap(localMap)
  } else {
    localMap = window.vue.getStoreMap()
  }

  // Custom store 추가
  var list = Register.register()

  for (var index = 0; index < list.length; index++) {
    let customSotre = list[index]
    let localInstance = customSotre.createInstance()
    localMap.set(customSotre.getName(), localInstance)
  }
}

var customStore = {}
customStore.init = init

export default customStore



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/user.js